export enum Status {
  New = 'new',
  Approved = 'approved',
  Denied = 'denied',
}
